export const POPULAR_COUNTRIES: Country[] = [
  { code: 'CH', nameEn: 'Switzerland', nameDe: 'Schweiz' },
  { code: 'DE', nameEn: 'Germany', nameDe: 'Deutschland' },
  { code: 'TR', nameEn: 'Turkey', nameDe: 'Türkei' },
  { code: 'IT', nameEn: 'Italy', nameDe: 'Italien' },
  { code: 'ER', nameEn: 'Eritrea', nameDe: 'Eritrea' },
  { code: 'XK', nameEn: 'Kosovo', nameDe: 'Kosovo' },
  { code: 'PT', nameEn: 'Portugal', nameDe: 'Portugal' },
  { code: 'FR', nameEn: 'France', nameDe: 'Frankreich' },
  { code: '-', nameEn: '', nameDe: '' },
];

export const OTHER_COUNTRIES: Country[] = [
  { code: 'AL', nameEn: 'Albania', nameDe: 'Albanien' },
  { code: 'AD', nameEn: 'Andorra', nameDe: 'Andorra' },
  { code: 'AE', nameEn: 'United Arab Emirates', nameDe: 'Vereinigte Arabische Emirate' },
  { code: 'AF', nameEn: 'Afghanistan', nameDe: 'Afghanistan' },
  { code: 'AG', nameEn: 'Antigua and Barbuda', nameDe: 'Antigua und Barbuda' },
  { code: 'AM', nameEn: 'Armenia', nameDe: 'Armenien' },
  { code: 'AO', nameEn: 'Angola', nameDe: 'Angola' },
  { code: 'AR', nameEn: 'Argentina', nameDe: 'Argentinien' },
  { code: 'AT', nameEn: 'Austria', nameDe: 'Österreich' },
  { code: 'AU', nameEn: 'Australia', nameDe: 'Australien' },
  { code: 'AZ', nameEn: 'Azerbaijan', nameDe: 'Aserbaidschan' },
  { code: 'BA', nameEn: 'Bosnia and Herzegovina', nameDe: 'Bosnien und Herzegowina' },
  { code: 'BB', nameEn: 'Barbados', nameDe: 'Barbados' },
  { code: 'BD', nameEn: 'Bangladesh', nameDe: 'Bangladesch' },
  { code: 'BE', nameEn: 'Belgium', nameDe: 'Belgien' },
  { code: 'BF', nameEn: 'Burkina Faso', nameDe: 'Burkina Faso' },
  { code: 'BG', nameEn: 'Bulgaria', nameDe: 'Bulgarien' },
  { code: 'BH', nameEn: 'Bahrain', nameDe: 'Bahrain' },
  { code: 'BI', nameEn: 'Burundi', nameDe: 'Burundi' },
  { code: 'BJ', nameEn: 'Benin', nameDe: 'Benin' },
  { code: 'BN', nameEn: 'Brunei Darussalam', nameDe: 'Brunei Darussalam' },
  { code: 'BO', nameEn: 'Bolivia', nameDe: 'Bolivien' },
  { code: 'BR', nameEn: 'Brazil', nameDe: 'Brasilien' },
  { code: 'BS', nameEn: 'Bahamas', nameDe: 'Bahamas' },
  { code: 'BT', nameEn: 'Bhutan', nameDe: 'Bhutan' },
  { code: 'BW', nameEn: 'Botswana', nameDe: 'Botsuana' },
  { code: 'BY', nameEn: 'Belarus', nameDe: 'Belarus' },
  { code: 'BZ', nameEn: 'Belize', nameDe: 'Belize' },
  { code: 'CA', nameEn: 'Canada', nameDe: 'Kanada' },
  { code: 'CD', nameEn: 'Congo, Democratic Republic of the', nameDe: 'Kongo, Demokratische Republik' },
  { code: 'CF', nameEn: 'Central African Republic', nameDe: 'Zentralafrikanische Republik' },
  { code: 'CG', nameEn: 'Congo', nameDe: 'Kongo' },
  { code: 'CI', nameEn: "Côte d'Ivoire", nameDe: "Côte d'Ivoire" },
  { code: 'CK', nameEn: 'Cook Islands', nameDe: 'Cookinseln' },
  { code: 'CL', nameEn: 'Chile', nameDe: 'Chile' },
  { code: 'CM', nameEn: 'Cameroon', nameDe: 'Kamerun' },
  { code: 'CN', nameEn: 'China', nameDe: 'China' },
  { code: 'CO', nameEn: 'Colombia', nameDe: 'Kolumbien' },
  { code: 'CR', nameEn: 'Costa Rica', nameDe: 'Costa Rica' },
  { code: 'CU', nameEn: 'Cuba', nameDe: 'Kuba' },
  { code: 'CV', nameEn: 'Cape Verde', nameDe: 'Cabo Verde' },
  { code: 'CY', nameEn: 'Cyprus', nameDe: 'Zypern' },
  { code: 'CZ', nameEn: 'Czech Republic', nameDe: 'Tschechien' },
  { code: 'DJ', nameEn: 'Djibouti', nameDe: 'Dschibuti' },
  { code: 'DK', nameEn: 'Denmark', nameDe: 'Dänemark' },
  { code: 'DM', nameEn: 'Dominica', nameDe: 'Dominica' },
  { code: 'DO', nameEn: 'Dominican Republic', nameDe: 'Dominikanische Republik' },
  { code: 'DZ', nameEn: 'Algeria', nameDe: 'Algerien' },
  { code: 'EC', nameEn: 'Ecuador', nameDe: 'Ecuador' },
  { code: 'EE', nameEn: 'Estonia', nameDe: 'Estland' },
  { code: 'EG', nameEn: 'Egypt', nameDe: 'Ägypten' },
  { code: 'ES', nameEn: 'Spain', nameDe: 'Spanien' },
  { code: 'ET', nameEn: 'Ethiopia', nameDe: 'Äthiopien' },
  { code: 'FI', nameEn: 'Finland', nameDe: 'Finnland' },
  { code: 'FJ', nameEn: 'Fiji', nameDe: 'Fidschi' },
  { code: 'FM', nameEn: 'Micronesia', nameDe: 'Mikronesien' },
  { code: 'FO', nameEn: 'Faeroe Islands', nameDe: 'Färöer' },
  { code: 'GA', nameEn: 'Gabon', nameDe: 'Gabun' },
  { code: 'GB', nameEn: 'United Kingdom', nameDe: 'Vereinigtes Königreich' },
  { code: 'GD', nameEn: 'Grenada', nameDe: 'Grenada' },
  { code: 'GE', nameEn: 'Georgia', nameDe: 'Georgien' },
  { code: 'GH', nameEn: 'Ghana', nameDe: 'Ghana' },
  { code: 'GM', nameEn: 'Gambia', nameDe: 'Gambia' },
  { code: 'GN', nameEn: 'Guinea', nameDe: 'Guinea' },
  { code: 'GQ', nameEn: 'Equatorial Guinea', nameDe: 'Äquatorialguinea' },
  { code: 'GR', nameEn: 'Greece', nameDe: 'Griechenland' },
  { code: 'GT', nameEn: 'Guatemala', nameDe: 'Guatemala' },
  { code: 'GW', nameEn: 'Guinea-Bissau', nameDe: 'Guinea-Bissau' },
  { code: 'GY', nameEn: 'Guyana', nameDe: 'Guyana' },
  { code: 'HN', nameEn: 'Honduras', nameDe: 'Honduras' },
  { code: 'HR', nameEn: 'Croatia', nameDe: 'Kroatien' },
  { code: 'HT', nameEn: 'Haiti', nameDe: 'Haiti' },
  { code: 'HU', nameEn: 'Hungary', nameDe: 'Ungarn' },
  { code: 'ID', nameEn: 'Indonesia', nameDe: 'Indonesien' },
  { code: 'IE', nameEn: 'Ireland', nameDe: 'Irland' },
  { code: 'IL', nameEn: 'Israel', nameDe: 'Israel' },
  { code: 'IN', nameEn: 'India', nameDe: 'Indien' },
  { code: 'IQ', nameEn: 'Iraq', nameDe: 'Irak' },
  { code: 'IR', nameEn: 'Iran', nameDe: 'Iran' },
  { code: 'IS', nameEn: 'Iceland', nameDe: 'Island' },
  { code: 'JM', nameEn: 'Jamaica', nameDe: 'Jamaika' },
  { code: 'JO', nameEn: 'Jordan', nameDe: 'Jordanien' },
  { code: 'JP', nameEn: 'Japan', nameDe: 'Japan' },
  { code: 'KE', nameEn: 'Kenya', nameDe: 'Kenia' },
  { code: 'KG', nameEn: 'Kyrgyzstan', nameDe: 'Kirgisistan' },
  { code: 'KH', nameEn: 'Cambodia', nameDe: 'Kambodscha' },
  { code: 'KI', nameEn: 'Kiribati', nameDe: 'Kiribati' },
  { code: 'KM', nameEn: 'Comoros', nameDe: 'Komoren' },
  { code: 'KN', nameEn: 'Saint Kitts and Nevis', nameDe: 'St. Kitts und Nevis' },
  { code: 'KP', nameEn: 'North Korea', nameDe: 'Nordkorea' },
  { code: 'KR', nameEn: 'South Korea', nameDe: 'Südkorea' },
  { code: 'KW', nameEn: 'Kuwait', nameDe: 'Kuwait' },
  { code: 'KZ', nameEn: 'Kazakhstan', nameDe: 'Kasachstan' },
  { code: 'LA', nameEn: 'Laos', nameDe: 'Laos' },
  { code: 'LB', nameEn: 'Lebanon', nameDe: 'Libanon' },
  { code: 'LC', nameEn: 'Saint Lucia', nameDe: 'St. Lucia' },
  { code: 'LI', nameEn: 'Liechtenstein', nameDe: 'Liechtenstein' },
  { code: 'LK', nameEn: 'Sri Lanka', nameDe: 'Sri Lanka' },
  { code: 'LR', nameEn: 'Liberia', nameDe: 'Liberia' },
  { code: 'LS', nameEn: 'Lesotho', nameDe: 'Lesotho' },
  { code: 'LT', nameEn: 'Lithuania', nameDe: 'Litauen' },
  { code: 'LU', nameEn: 'Luxembourg', nameDe: 'Luxemburg' },
  { code: 'LV', nameEn: 'Latvia', nameDe: 'Lettland' },
  { code: 'LY', nameEn: 'Libya', nameDe: 'Libyen' },
  { code: 'MA', nameEn: 'Morocco', nameDe: 'Marokko' },
  { code: 'MC', nameEn: 'Monaco', nameDe: 'Monaco' },
  { code: 'MD', nameEn: 'Moldova', nameDe: 'Moldawien' },
  { code: 'ME', nameEn: 'Montenegro', nameDe: 'Montenegro' },
  { code: 'MG', nameEn: 'Madagascar', nameDe: 'Madagaskar' },
  { code: 'MH', nameEn: 'Marshall Islands', nameDe: 'Marshallinseln' },
  { code: 'MK', nameEn: 'North Macedonia', nameDe: 'Nordmazedonien' },
  { code: 'ML', nameEn: 'Mali', nameDe: 'Mali' },
  { code: 'MM', nameEn: 'Myanmar', nameDe: 'Myanmar' },
  { code: 'MN', nameEn: 'Mongolia', nameDe: 'Mongolei' },
  { code: 'MR', nameEn: 'Mauritania', nameDe: 'Mauretanien' },
  { code: 'MT', nameEn: 'Malta', nameDe: 'Malta' },
  { code: 'MU', nameEn: 'Mauritius', nameDe: 'Mauritius' },
  { code: 'MV', nameEn: 'Maldives', nameDe: 'Malediven' },
  { code: 'MW', nameEn: 'Malawi', nameDe: 'Malawi' },
  { code: 'MX', nameEn: 'Mexico', nameDe: 'Mexiko' },
  { code: 'MY', nameEn: 'Malaysia', nameDe: 'Malaysia' },
  { code: 'MZ', nameEn: 'Mozambique', nameDe: 'Mosambik' },
  { code: 'NA', nameEn: 'Namibia', nameDe: 'Namibia' },
  { code: 'NE', nameEn: 'Niger', nameDe: 'Niger' },
  { code: 'NG', nameEn: 'Nigeria', nameDe: 'Nigeria' },
  { code: 'NI', nameEn: 'Nicaragua', nameDe: 'Nicaragua' },
  { code: 'NL', nameEn: 'Netherlands', nameDe: 'Niederlande' },
  { code: 'NO', nameEn: 'Norway', nameDe: 'Norwegen' },
  { code: 'NP', nameEn: 'Nepal', nameDe: 'Nepal' },
  { code: 'NR', nameEn: 'Nauru', nameDe: 'Nauru' },
  { code: 'NU', nameEn: 'Niue', nameDe: 'Niue' },
  { code: 'NZ', nameEn: 'New Zealand', nameDe: 'Neuseeland' },
  { code: 'OM', nameEn: 'Oman', nameDe: 'Oman' },
  { code: 'PA', nameEn: 'Panama', nameDe: 'Panama' },
  { code: 'PE', nameEn: 'Peru', nameDe: 'Peru' },
  { code: 'PG', nameEn: 'Papua New Guinea', nameDe: 'Papua-Neuguinea' },
  { code: 'PH', nameEn: 'Philippines', nameDe: 'Philippinen' },
  { code: 'PK', nameEn: 'Pakistan', nameDe: 'Pakistan' },
  { code: 'PL', nameEn: 'Poland', nameDe: 'Polen' },
  { code: 'PS', nameEn: 'Palestine', nameDe: 'Palästina' },
  { code: 'PW', nameEn: 'Palau', nameDe: 'Palau' },
  { code: 'PY', nameEn: 'Paraguay', nameDe: 'Paraguay' },
  { code: 'QA', nameEn: 'Qatar', nameDe: 'Katar' },
  { code: 'RO', nameEn: 'Romania', nameDe: 'Rumänien' },
  { code: 'RS', nameEn: 'Serbia', nameDe: 'Serbien' },
  { code: 'RU', nameEn: 'Russia', nameDe: 'Russland' },
  { code: 'RW', nameEn: 'Rwanda', nameDe: 'Ruanda' },
  { code: 'SA', nameEn: 'Saudi Arabia', nameDe: 'Saudi-Arabien' },
  { code: 'SB', nameEn: 'Solomon Islands', nameDe: 'Salomonen' },
  { code: 'SC', nameEn: 'Seychelles', nameDe: 'Seychellen' },
  { code: 'SD', nameEn: 'Sudan', nameDe: 'Sudan' },
  { code: 'SE', nameEn: 'Sweden', nameDe: 'Schweden' },
  { code: 'SG', nameEn: 'Singapore', nameDe: 'Singapur' },
  { code: 'SI', nameEn: 'Slovenia', nameDe: 'Slowenien' },
  { code: 'SK', nameEn: 'Slovakia', nameDe: 'Slowakei' },
  { code: 'SL', nameEn: 'Sierra Leone', nameDe: 'Sierra Leone' },
  { code: 'SM', nameEn: 'San Marino', nameDe: 'San Marino' },
  { code: 'SN', nameEn: 'Senegal', nameDe: 'Senegal' },
  { code: 'SO', nameEn: 'Somalia', nameDe: 'Somalia' },
  { code: 'SR', nameEn: 'Suriname', nameDe: 'Suriname' },
  { code: 'SS', nameEn: 'South Sudan', nameDe: 'Südsudan' },
  { code: 'ST', nameEn: 'Sao Tome and Principe', nameDe: 'São Tomé und Príncipe' },
  { code: 'SV', nameEn: 'El Salvador', nameDe: 'El Salvador' },
  { code: 'SY', nameEn: 'Syria', nameDe: 'Syrien' },
  { code: 'SZ', nameEn: 'Swaziland', nameDe: 'Eswatini' },
  { code: 'TD', nameEn: 'Chad', nameDe: 'Tschad' },
  { code: 'TG', nameEn: 'Togo', nameDe: 'Togo' },
  { code: 'TH', nameEn: 'Thailand', nameDe: 'Thailand' },
  { code: 'TJ', nameEn: 'Tajikistan', nameDe: 'Tadschikistan' },
  { code: 'TL', nameEn: 'Timor-Leste', nameDe: 'Timor-Leste' },
  { code: 'TM', nameEn: 'Turkmenistan', nameDe: 'Turkmenistan' },
  { code: 'TN', nameEn: 'Tunisia', nameDe: 'Tunesien' },
  { code: 'TO', nameEn: 'Tonga', nameDe: 'Tonga' },
  { code: 'TT', nameEn: 'Trinidad and Tobago', nameDe: 'Trinidad und Tobago' },
  { code: 'TV', nameEn: 'Tuvalu', nameDe: 'Tuvalu' },
  { code: 'TW', nameEn: 'Taiwan', nameDe: 'Taiwan' },
  { code: 'TZ', nameEn: 'Tanzania', nameDe: 'Tansania' },
  { code: 'UA', nameEn: 'Ukraine', nameDe: 'Ukraine' },
  { code: 'UG', nameEn: 'Uganda', nameDe: 'Uganda' },
  { code: 'US', nameEn: 'United States', nameDe: 'Vereinigte Staaten' },
  { code: 'UY', nameEn: 'Uruguay', nameDe: 'Uruguay' },
  { code: 'UZ', nameEn: 'Uzbekistan', nameDe: 'Usbekistan' },
  { code: 'VA', nameEn: 'Vatican City', nameDe: 'Vatikanstadt' },
  { code: 'VC', nameEn: 'Saint Vincent and the Grenadines', nameDe: 'St. Vincent und die Grenadinen' },
  { code: 'VE', nameEn: 'Venezuela', nameDe: 'Venezuela' },
  { code: 'VN', nameEn: 'Viet Nam', nameDe: 'Vietnam' },
  { code: 'VU', nameEn: 'Vanuatu', nameDe: 'Vanuatu' },
  { code: 'WS', nameEn: 'Samoa', nameDe: 'Samoa' },
  { code: 'YE', nameEn: 'Yemen', nameDe: 'Jemen' },
  { code: 'ZA', nameEn: 'South Africa', nameDe: 'Südafrika' },
  { code: 'ZM', nameEn: 'Zambia', nameDe: 'Sambia' },
  { code: 'ZW', nameEn: 'Zimbabwe', nameDe: 'Simbabwe' },
] as Country[];

export type Country = {
  code: string;
  nameEn: string;
  nameDe: string;
};
